import jsPDF from "jspdf";
import "jspdf-autotable";
import dayjs from "dayjs";
import dataStatusAR from "../data/dataStatusAR";
import "../../../../assets/font/THSarabunNew-normal";
import "../../../../assets/font/THSarabunNew-bold";

const getStatusLabel = (status) =>
  dataStatusAR.find((item) => item.value === Number(status))?.label || "-";

/**
 * exportFinanceReportPDF
 * สร้าง PDF จากข้อมูลตาราง "พิมพ์รายงานส่งการเงินตามรอบ"
 */
export const exportFinanceReportPDF = (
  data,
  { title = "รายงานส่งการเงินตามรอบ", subtitle = "" } = {},
) => {
  const tableColumns = [
    "ลำดับ",
    "เลขสัญญา",
    "รายละเอียด",
    "วันที่ CEO อนุมัติ",
    "รอบการส่ง",
    "สถานะสัญญา",
    "ประเภท",
  ];

  const tableRows = data.map((item, index) => [
    String(index + 1),
    item.contno || "-",
    item.cnam || "-",
    item.decidedAt ? dayjs(item.decidedAt).format("DD/MM/YYYY") : "-",
    item.roundDate ? dayjs(item.roundDate).format("DD/MM/YYYY") : "-",
    getStatusLabel(item.status),
    item.caseType === 1 ? "ที่ดิน" : "รถ",
  ]);

  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  const PAGE_W = doc.internal.pageSize.getWidth();
  const MARGIN = 10;

  doc.setFont("THSarabunNew", "bold");
  doc.setFontSize(20);
  doc.text(title, MARGIN, 16);

  doc.setFont("THSarabunNew", "normal");
  doc.setFontSize(13);
  if (subtitle) doc.text(subtitle, MARGIN, 24);
  doc.text(`จำนวนทั้งหมด: ${data.length} รายการ`, MARGIN, subtitle ? 30 : 24);

  doc.autoTable({
    head: [tableColumns],
    body: tableRows,
    startY: subtitle ? 36 : 30,
    margin: { left: MARGIN, right: MARGIN },
    styles: {
      font: "THSarabunNew",
      fontSize: 11,
      cellPadding: 3,
      overflow: "linebreak",
      lineColor: [210, 210, 210],
      lineWidth: 0.1,
      textColor: [30, 30, 30],
    },
    headStyles: {
      font: "THSarabunNew",
      fillColor: [31, 97, 209],
      textColor: [255, 255, 255],
      fontStyle: "bold",
      halign: "center",
    },
    columnStyles: {
      0: { halign: "center", cellWidth: 15 },
      1: { halign: "center" },
      3: { halign: "center" },
      4: { halign: "center" },
      5: { halign: "center" },
      6: { halign: "center" },
    },
    alternateRowStyles: { fillColor: [235, 245, 251] },
  });

  const totalPages = doc.internal.getNumberOfPages();
  for (let p = 1; p <= totalPages; p++) {
    doc.setPage(p);
    doc.setFont("THSarabunNew", "normal");
    doc.setFontSize(10);
    doc.text(
      `หน้า ${p} / ${totalPages}`,
      PAGE_W - MARGIN,
      doc.internal.pageSize.getHeight() - 6,
      { align: "right" },
    );
  }

  doc.save(`${title}.pdf`);
};
